import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import  * as moment  from 'moment';

@Component({
    selector: 'modal-cancel',
    templateUrl: '../../templates/partials/modal-cancel.html'
})

export class ModalCancelComponent implements OnInit {
    @Input() showModal;
    @Input() modalData;
    @Output() emitCloseModal = new EventEmitter();
    public cancelReason: FormGroup;
    public showFeeDisclaimer = false;
    public allowToPenalize = false;
    public disableButton = false;
    @ViewChild('cancelModal') public cancelModal:ModalDirective;
    
    constructor(private _fb: FormBuilder) { }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public cancelService(){
        var reason;
        let penalize;
        this.disableButton = true;
        if(this.showFeeDisclaimer) penalize = (this.allowToPenalize) ? 1 : 0;
        else penalize = null;
        if(this.cancelReason.controls.comment.value != null && this.cancelReason.controls.comment.value != ''){
            reason = this.cancelReason.controls.reason.value + ":" 
            + encodeURI(this.cancelReason.controls.comment.value);
            this.emitCloseModal.emit({action:"cancel", data: this.modalData, reason: reason, penalized: penalize});
           
        }else{
            reason = this.cancelReason.controls.reason.value;
            this.emitCloseModal.emit({action:"cancel", data: this.modalData, reason: reason, penalized: penalize});
        }
    }

    public cancelAllServices() {
        var reason;
        let penalize;
        this.disableButton = true;
        if(this.showFeeDisclaimer) penalize = (this.allowToPenalize) ? 1 : 0;
        else penalize = null;
        if(this.cancelReason.controls.comment.value != null && this.cancelReason.controls.comment.value != ''){
            reason = this.cancelReason.controls.reason.value + ":" 
            + encodeURI(this.cancelReason.controls.comment.value);
            this.emitCloseModal.emit({action:"cancelAll", data: this.modalData, reason: reason, penalized: penalize});
           
        }else{
            reason = this.cancelReason.controls.reason.value;
            this.emitCloseModal.emit({action:"cancelAll", data: this.modalData, reason: reason, penalized: penalize});
        }
    }

    ngOnChanges(value) {
        (this.showModal) ? this.cancelModal.show() : this.cancelModal.hide();
        if(Object.keys( this.modalData).length){
            this.showDisclaimer();
        }
    }

    ngOnInit() { 
        this.cancelReason = this._fb.group({
            reason: ['', [Validators.required]],
            comment: ['', []],
        });
        this.cancelReason.valueChanges.subscribe(data => {
            if(this.cancelReason.controls.reason.value == 'Manager:Otros%20motivos'){
                if(this.cancelReason.controls.comment.value == ''){
                    this.cancelReason.controls['comment'].setErrors({'incorrect': true});
                }else{
                    this.cancelReason.controls['comment'].setErrors(null);
                }
            }else{
                this.cancelReason.controls['comment'].setErrors(null);
            }
     });
    }

    private showDisclaimer() {
        let today = moment().format("YYYY-MM-DD HH:mm");
        let dateParsed = moment(this.modalData["date"], "DD/MM/YYYY").format("YYYY-MM-DD");
        let dateService = dateParsed + " " + this.modalData["time_ini"];
        dateService = moment(dateService, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
        
        var duration = moment(dateService, "YYYY-MM-DD HH:mm").diff(moment(today, "YYYY-MM-DD HH:mm"), 'minutes');
        duration = duration / 60;
        if(duration < 18) {
            this.showFeeDisclaimer = true;
        }else{
            this.showFeeDisclaimer = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/modal-cancel.component.ts